<template>
  <div class="login">
    <div class="title">
      <img src="../../assets/img/LOGO.png" alt />
    </div>
    <div>
      <h3 class="name">企業級數字資產守護者</h3>
    </div>
    <div>
      <p class="describe">外禦黑客·內防家賊</p>
    </div>
    <div class="main-login">
      <Form ref="formValidate" :model="formData" :rules="ruleValidate" :label-width="80">
        <!-- <FormItem label="商戶名稱" prop="merchantName">
          <Input v-model="formData.merchantName" placeholder="請輸入公司、項目或平臺名稱等"></Input>
        </FormItem> -->
        <FormItem label="郵箱號" prop="email">
          <Input v-model.trim="formData.email" placeholder="請輸入郵箱號"></Input>
        </FormItem>
        <FormItem label="驗證碼" prop="phoneCode">
          <Input v-model.trim="formData.phoneCode" placeholder="請輸入驗證碼">
            <Button
              slot="append"
              v-if="currentTime===60 || currentTime === 0"
              @click="getCode"
            >獲取驗證碼</Button>
            <Button slot="append" v-else disabled>{{currentTime}}s後重新發送</Button>
          </Input>
        </FormItem>
        <FormItem label="登錄密碼" prop="password">
          <Input
            v-model.trim="formData.password"
            type="password"
            password
            placeholder="設置8-16位英文大小寫字母,數字"
          ></Input>
        </FormItem>
        <FormItem label="聯系方式">
          <CheckboxGroup v-model="formData.contractType">
            <Checkbox v-for="contract in contractType" :label="contract.key" :key="contract.key">{{contract.key}}</Checkbox>
          </CheckboxGroup>
          <Input v-model='formData.ownerName' placeholder="聯系方式，多個請換行填寫（選填）" type="textarea" :rows="contractType.size"></Input>
        </FormItem>
        <!-- <el-checkbox-group v-if='steps===4' v-model="formDataMail.contractType" style="margin: 20px 0">
            <el-checkbox v-for="contract in contractType" :label="contract.key" :key="contract.key">{{contract.key}}</el-checkbox>
          </el-checkbox-group>
          <el-form-item prop='ownerName' v-if='steps===4' style="margin-bottom:50px">
            <el-input v-model='formDataMail.ownerName' :placeholder="$t('login.concact')" type="textarea" :rows="contractType.size"/>
          </el-form-item> -->
      </Form>
    </div>
    <div class="right-register">
      <Button type="success" @click="handleSubmit('formValidate')" :loading="loading">立即註冊</Button>
    </div>
    <div style="margin-top:10px">
      <p>點擊 「註冊」按鈕, 即代表您已知曉並同意優盾錢包如下協議</p>
      <a style="color:green" href="https://home.uduncloud.com/agreement">《優盾錢包用戶服務協議》</a>
    </div>
    <div>
      <Modal
        v-model="agreementVisible"
        :closable="false"
        :mask-closable="false"
        class-name="vertical-center-modal"
        title="優盾錢包用戶服務協議">
        <div class="agree-dialog">
          <agreement-List></agreement-List>
        </div>
        <div slot="footer">
          <div class="agree-foot">
            <p>您在點擊同意該協議前，請您務必審慎閱讀，並充分理解協議條款內容。</p>
    <Button type="success" @click="agree(1)">同意</Button>
    <Button type="warning" @click="agree(2)">不同意</Button></div>
        </div>
    </Modal>
    </div>
  </div>
</template>
<script>
import {
  sensitiveCharacter,onlyLNU,required
} from '@/libs/rules'
import agreementList from '@/components/agreement'
export default {
  components:{
    agreementList
  },
  data() {
    return {
      agreeStatus:2,
      agreementVisible:true,
      loading:false,
      onOff: false,
      currentTime: 60,
      countryList: [],
      timer: null,
      formData: {
        merchantName: "",
        // phoneNo: "",
        phoneCode: "",
        email: "",
        contractType: [],
        ownerName: null,
        // prefix: "0086",
        loginCode: ""
      },
      ruleValidate: {
        merchantName: [
          required(),
          {
            validator: sensitiveCharacter,
            trigger: "blur"
          }
        ],
        phoneNo: [
          {
            required: true,
            message: "此項為必填項",
            trigger: "blur"
          }
        ],
        phoneCode: [
          {
            required: true,
            message: "此項為必填項",
            trigger: "blur"
          }
        ],
        prefix: [
          {
            required: true,
            message: "此項為必填項",
            trigger: "blur"
          }
        ],
        password: [
          required(),
          {
            min: 8,
            max: 16,
            message: '請輸入8-16位英文大小寫字母、數字組合的密碼',
            trigger: 'blur'
          },
           {
            validator: onlyLNU,
            trigger: 'blur'
          }
        ]
      },
      contractType: [
        {
          key: 'Mobile',
          cn: 'Mobile',
          en: 'Mobile'
        },
        {
          key: 'WhatsApp',
          cn: 'WhatsApp',
          en: 'WhatsApp'
        },
        {
          key: 'Telegram',
          cn: 'Telegram',
          en: 'Telegram'
        }
      ]
    };
  },
  methods: {
    agree(item){
      this.agreementVisible = false
      this.agreeStatus = item
    },
    handleSubmit(name) {
      if(this.agreeStatus==2){
        this.agreementVisible = true
        return false
      }
      this.$refs[name].validate(valid => {
        if (valid) {
          this.loading = true
          let ownerNameDetail = ""
          if (this.formData.ownerName) {
            ownerNameDetail = this.formData.contractType.join(',') + ';' + this.formData.ownerName.replace(/[(\r\n)\r\n]+/g, ',')
          }
          this.$api
            .userRegisterNew({
              area: -1,
              merchantName: this.formData.merchantName,
              password: this.formData.password.trim(),
              phoneCode: this.formData.phoneCode.trim(),
              phoneNo: null,
              prefix: null,
              email: this.formData.email.trim(),
              registerType: "mail",
              ownerName: ownerNameDetail,
              inviteCode: this.$route.query.inviteCode
            })
            .then(res => {
              if (res.data.code == 200) {
                this.loading =false
                this.$Message.success("註冊成功");
                this.$router.push({ name: "success" });
              } else {
                this.loading = false
                this.$Message.error(res.data.message);
                return false;
              }
            });
        } else {
          this.loading = false
          this.$Message.error("請輸入完整信息");
        }
      });
    },
    // 获取验证码
    async getCode() {
      if (this.formData.email) {
        if (!this.onOff) {
          this.onOff = true;
          this.$api
            .registerEmailCode({
              email: this.formData.email.trim()
            })
            .then(res => {
              if (res.data.code == 200) {
                this.$Message.success("驗證碼發送成功！");
                this.getTime();
                this.onOff = false;
              } else if (res.data.code == 327 || res.data.code == 3261) {
                this.$Message.error(res.data.message);
                this.onOff = false;
                return false;
              } else {
                return false;
                this.onOff = false;
              }
            });
        }
      } else {
        this.$Message.error("請輸入郵箱號");
      }
    },
    // 倒计时60s
    getTime() {
      const TIME_COUNT = 60;
      if (!this.timer) {
        this.currentTime = TIME_COUNT;
        this.timer = setInterval(() => {
          if (this.currentTime > 0 && this.currentTime <= TIME_COUNT) {
            this.currentTime -= 1;
          } else {
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
      }
    },
    async getPrefix() {
      let res = await this.$api.phonePrefix();
      this.countryList = res.data[0].value;
    },
    async getContract() {
      let res = await this.$api.contract();
      this.contractType = res
    }
  },
  created() {
    if(this.$route.query.channel){
      window.localStorage.setItem("channel",this.$route.query.channel)
    }
    if (!window.localStorage.getItem('channel') && !this.$route.query.channel) {
      window.localStorage.setItem('channel', '')
    }
    // this.getPrefix();
    // this.getContract()
  }
};
</script>
<style >
.ivu-modal-header{
  text-align: center;
}
.agree-dialog{
  height: 400px;
  overflow-y: auto;
}
.agree-foot{
  text-align: center;
}
.agree-foot p{
  margin-bottom: 10px;
  color:#000;
}
.ivu-input {
  height: 40px;
}
.ivu-form-item-required .ivu-form-item-label:before {
  content: "";
  display: inline-block;
  margin-right: 4px;
  line-height: 1;
  font-family: SimSun;
  font-size: 12px;
}
.title img {
  width: 4.9rem;
  height: 5.3rem;
  margin-top: 22px;
  margin-bottom: 16px;
}
h3.name {
  font-size: 26px;
  color: #000;
  margin-bottom: 0.7rem;
}
p.describe {
  font-size: 15px;
  color: #000;
}
/* .main-login {
  border-radius: 5px;
  border: 1px solid #f7f7f7;
  padding: 20px 10px 0 10px;
  margin-bottom: 2.7rem;
} */
@media screen and (max-width: 768px) {
  .main-login {
    border-radius: 5px;
    border: 1px solid #f7f7f7;
    padding: 20px 10px 0 10px;
    margin-bottom: 2.7rem;
    margin-top: 4.8rem;
  }
  .title img {
    width: 4.9rem;
    height: 5.3rem;
    margin-top: 22px;
    margin-bottom: 16px;
  }
  .right-register button {
    width: 100%;
    height: 4rem;
    font-size: 18px;
    border-radius: 5px;
  }
  .login {
    padding: 0 20px;
  }
}
@media screen and (min-width: 768px) {
  .title img {
    width: 50px;
    height: 50px;
    margin-top: 22px;
    margin-bottom: 16px;
  }
  .main-login {
    border-radius: 5px;
    border: 1px solid #f7f7f7;
    padding: 20px 10px 0 10px;
    margin: 0 auto;
    margin-bottom: 40px;
    margin-top: 50px;
    width: 40%;
  }
  .right-register button {
    width: 40%;
    height: 40px;
    font-size: 18px;
    border-radius: 5px;
  }
  /* .login {
  height: 100%;
  background-image: url("../../assets/img/login-backgroun2.jpg");
  background-size: cover;
} */
}
</style>
